import React from 'react';

// Estilos
import './Menu.style.scss';

// Redux
import { ObserverAnim, GLOBAL_EVENT_ANIM } from '../../Observer';
// import { Link } from 'react-router-dom';
import getFilesText from '../../../../utils/getFilesText';
import isPhaserAnimationJSON from '../../../../utils/isPhaserAnimationJSON';
import generateId from '../../../../utils/generateId';
import store, { RootState } from '../../../../Redux/Store/store';
import generateRandomColors from '../../../../utils/generateRandomColors';
import { useDispatch, useSelector } from 'react-redux';
import {
    SwipeAnimationsAction,
    PlayStopAction,
} from '../../../../Redux/Actions/Animator/animation.list.action';
import { isEmpty } from 'ramda';
import { css } from 'glamor';
import { SetAtlasAnimAnimAction } from '../../../../Redux/Actions/Animator/atlas.anim.action';
import { ResetAllAnimationAction } from '../../../../Redux/Actions/globals.actions';
import Patreon from '../../../../Vendor/become_patreon.png';
import isElectron from 'is-electron';
import { Link } from 'react-router-dom';
const disable = css({
    opacity: 0.2,
});

const MenuComponent: React.FunctionComponent = () => {
    const atlas_anim = useSelector((store: RootState) => store.atlasAnim);
    const dispatch = useDispatch();

    const handleClickOpenModalAtlasImport = () => {
        ObserverAnim.emit(GLOBAL_EVENT_ANIM.OPEN_ATLAS_IMPORT_MODAL);
    };

    const inputHandleAnimationJson = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const files = event.target.files;
        const files_loaded = await getFilesText(files);

        if (isPhaserAnimationJSON(files_loaded as string)) {
            const imagesAtlas = store.getState().imagesAtlas;

            const anim_json = JSON.parse(files_loaded as string);
            const animations = anim_json.anims.map((anim: any) => ({
                id: generateId('anim'),
                name: anim.key,
                color: generateRandomColors(),
                play: false,
                key_controls: {
                    repeat: anim.repeat,
                    frame_rate: anim.frameRate,
                    yoyo: false,
                },
                frames: anim.frames.reduce((prevFrame: any, currentFrame: any) => {
                    const local_frame = imagesAtlas.find(
                        (image: any) => image.name === currentFrame.frame
                    );
                    if (local_frame !== undefined) {
                        prevFrame.push({
                            id: local_frame.id,
                            local_id: generateId('sprite'),
                            name: currentFrame.frame,
                            src: local_frame.src,
                            active: false,
                        });
                    }
                    return prevFrame;
                }, []),
            }));

            // Se ha usado swipeanimationaction ya que provee la posibilidad de insertar un array de animaciones
            dispatch(SwipeAnimationsAction(animations));
            dispatch(SetAtlasAnimAnimAction(files_loaded));
        } else {
            ObserverAnim.emit(
                GLOBAL_EVENT_ANIM.NOTIFICATION_SYSTEM.ERROR,
                'Atlas anim incorrect json'
            );
        }
    };

    return (
        <nav className="menu noselect">
            <ul>
                <li className="icon">
                    {isElectron() ? (
                        <Link to="/" className="material-icons">
                            home
                        </Link>
                    ) : (
                        <a href="https://gammafp.com" className="material-icons">
                            home
                        </a>
                    )}
                </li>
                {!isEmpty(atlas_anim.image) && !isEmpty(atlas_anim.json) ? (
                    <li
                        className={`${disable}`}
                        onClick={() => {
                            ObserverAnim.emit(
                                GLOBAL_EVENT_ANIM.NOTIFICATION_SYSTEM.WARNING,
                                'You have already imported an atlas'
                            );
                        }}
                    >
                        Import Atlas
                    </li>
                ) : (
                    <li onClick={handleClickOpenModalAtlasImport}>Import Atlas</li>
                )}
                {!isEmpty(atlas_anim.image) &&
                !isEmpty(atlas_anim.json) &&
                isEmpty(atlas_anim.animation) ? (
                    <li className="fileUpload">
                        Import Animation
                        <input
                            type="file"
                            className="upload cursor-pointer uploadSprites"
                            accept="application/json"
                            onChange={inputHandleAnimationJson}
                        />
                    </li>
                ) : (
                    <li
                        className={`${disable}`}
                        onClick={() => {
                            isEmpty(atlas_anim.animation)
                                ? ObserverAnim.emit(
                                      GLOBAL_EVENT_ANIM.NOTIFICATION_SYSTEM.WARNING,
                                      'You must import an atlas'
                                  )
                                : ObserverAnim.emit(
                                      GLOBAL_EVENT_ANIM.NOTIFICATION_SYSTEM.WARNING,
                                      'You have already imported animations'
                                  );
                        }}
                    >
                        Import Animation
                    </li>
                )}
                {/* TODO: Refactor reset */}
                <li
                    onClick={() => {
                        dispatch(PlayStopAction({ id: '0', play: false }));
                        dispatch(ResetAllAnimationAction());
                        ObserverAnim.emit(GLOBAL_EVENT_ANIM.RESET_ALL);
                    }}
                >
                    Reset
                </li>
                <li>
                    <a
                        href="https://www.patreon.com/join/gammafp?"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img src={Patreon} alt="Patreon" />
                    </a>
                </li>
            </ul>
        </nav>
    );
};

export default MenuComponent;
